import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, RefreshCwIcon } from 'lucide-react';
export function FramingSection() {
  const cycleSteps = ['Consumo', 'Emoción', 'Duda', 'Pausa', 'Culpa', 'Consumo'];
  return <section className="py-20 px-4 bg-cream-50 overflow-hidden" data-id="element-79">
      <div className="max-w-4xl mx-auto text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-800 mb-6" data-id="element-82">
            No te faltan ganas. <br data-id="element-83" />
            <span className="text-terracotta-500" data-id="element-84">Te falta secuencia.</span>
          </h2>
          <p className="text-lg text-stone-600" data-id="element-85">
            La mayoría se queda atrapada en este ciclo:
          </p>
        </motion.div>

        {/* Cycle Visualization */}
        <div className="relative mb-16 py-8" data-id="element-86">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8" data-id="element-87">
            {cycleSteps.map((step, index) => <Fragment key={index} data-id="element-88">
                <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.15
            }} className="bg-white px-6 py-3 rounded-full shadow-md border border-cream-200 font-bold text-brown-800 z-10" data-id="element-89">
                  {step}
                </motion.div>
                {index < cycleSteps.length - 1 && <motion.div initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.15 + 0.1
            }} data-id="element-90">
                    <ArrowRightIcon className="w-5 h-5 text-terracotta-500" data-id="element-91" />
                  </motion.div>}
              </Fragment>)}
          </div>

          {/* Decorative circular arrow for mobile/desktop visualization hint */}
          <motion.div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5" animate={{
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-92">
            <RefreshCwIcon className="w-64 h-64" data-id="element-93" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="bg-terracotta-500 text-white p-8 md:p-10 rounded-2xl shadow-xl mx-auto max-w-3xl" data-id="element-94">
          <p className="text-xl md:text-2xl font-serif leading-relaxed" data-id="element-95">
            Este plan rompe ese ciclo con una sola cosa: <br data-id="element-96" />
            <span className="font-sans font-bold bg-white/20 px-2 rounded" data-id="element-97">
              14 días de micro-decisiones guiadas.
            </span>
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4 text-terracotta-100 font-medium" data-id="element-98">
            <span className="flex items-center gap-2" data-id="element-99">
              <span className="w-2 h-2 bg-white rounded-full" data-id="element-100"></span> Sin
              perfección
            </span>
            <span className="flex items-center gap-2" data-id="element-101">
              <span className="w-2 h-2 bg-white rounded-full" data-id="element-102"></span> Sin drama
            </span>
            <span className="flex items-center gap-2" data-id="element-103">
              <span className="w-2 h-2 bg-white rounded-full" data-id="element-104"></span> Con pasos
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}